import { FormsModule } from '@angular/forms';
import {
  Component, OnInit, Inject, Injectable, CUSTOM_ELEMENTS_SCHEMA, NgModule,
  Input//, trigger, state, style, transition, animate, keyframes,
} from '@angular/core';
//Rewrite Angular HTTP service after update
//import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import * as _ from 'underscore';
import { CommonSerivce } from '../shared/services/common.service'
import { UserService } from '../shared/services/user.service';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { GrowlModule } from 'primeng/growl';
import { FileUploadModule } from 'primeng/fileupload';
import { RadioButtonModule } from 'primeng/radiobutton';
import { EditorModule } from 'primeng/editor';
import { PaginatorModule } from 'primeng/paginator';
import { CalendarModule } from 'primeng/calendar';
import { FieldsetModule } from 'primeng/fieldset';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';

import { DatePipe } from '@angular/common';
import { saveAs as importedSaveAs } from "file-saver";
import { Session } from 'inspector';

import { Router, ActivatedRoute } from '@angular/router';
import { TabView } from 'primeng/tabview';

import * as XLSX from "xlsx-js-style";

import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;


import { JSDocTagName } from '@angular/compiler/src/output/output_ast';
import { Table } from 'primeng/table';
import { Header } from 'primeng/primeng';

@Component({
  selector: 'etsReport',
  styleUrls: ['../shared/share.component.css'],
  providers: [CommonSerivce, UserService, DatePipe, ConfirmationService],
  templateUrl: './etsReport.component.html'
})


export class EtsReportComponent {

  /*
      RecordList - Search result list
      SelectedRecordList - User selected record (Multiple) in the result table
      SelectedRecord - User selected record (Single) for edition
  */
  public OutstandingSeverityList: IOutstandingSeverity[];
  public ResponseAnalysisList: IResponseAnalysis[];
  //public ExportOutstandingSeverityList: IOutstandingSeverity[];
  public InputErrorMsg: Message[] = [];

  //  Hold the value of the user inputted search field, to be used for searching
  public SearchFieldHolder: any;
  public SearchFieldHolder01: any;
  public SeveritySearchFields: ISeveritySearchFields;

  //Code value list for List Box, add required code value list
  public Reports_List: IReportsListValue[];
  public DomainList: IDomainValue[];
  public SeverityList: ICodeValue[];
  public CaseStatusList: ICodeValue[];

  public loggedInType: string = "";
  public loggedInCompanyCode: string = "";


  /*
      sort0 - define the sorting sequence for the table field (1 asc, 0 desc)
      softF - define the sorting field name
  */
  sortO: number = 0;
  sortF: string = 'id';


  /*
      Major control variables
          FormTitle - Initial Form Title for the landing form
          PrimaryApiPath - Path for the API controller per component 
          ShowEditForm/ ShowAddForm - control whether to show Inquiry or Edit form
          ShowUploadForm - control whether to show Upload form
          AutoReload - control auto reload component
          
  */
  FormTitle: String = "Work with Tender Reports";
  FormAccessRight: String = "NA";
  PrimaryApiPath: string = "api/EtsReport/";
  ListValueApiPath: string = "api/BcpListValue/";

  //Determine which report to show
  ShowSeveritySearchFields: Boolean = false;
  ShowOutstandingSeverityPerformance: Boolean = false;
  ShowTestingSearchFields: Boolean = false;
  ShowTestingReport: Boolean = false;

  scrollHeight: string = "";
  scrollWidth: string = "";
  public CurrentForm: string = "BcpCase";

  httpOriginalUrl: String;
  httpHeaders = new Headers();
  isLoggedIn: boolean = false;
  dateFormat: String = "yy-mm-dd";
  dateRange: String;

  arrayBuffer: any;
  uploadFile: File;

  cachedExpiryDate: String = "";

  //excel variable
  strLine: string;
  excelRow: string[] = [];
  SheetNames = [];
  Sheets = {};
  cellList: string[];
  lastRowNumber: number;
  currentProcessRow: number = -1;
  currentProcessColumn: number = -1;
  rangeFromColumn: number = -1;
  rangeFromRow: number = -1;
  rangeToColumn: number = -1;
  rangeToRow: number = -1;
  delimiter: string = "|";
  //excel variable - End

  processingFlag: string = "N";
  processingReport: string = "";

  //Display Warning/ Error Message
  public searchErrorMsgs: Message[] = [];
  public confirmMsgs: Message[] = [];
  public resultMsgs: Message[] = [];

  //Initialize Table Column Header
  public responseAnalysisCols: any;
  public outstandingSeverityCols: any;
  public testingReportCols: any;

  public selectedTab: string;
  public selectedReportName: string;
  public stringifyValue = "";

  constructor(private http: HttpClient, @Inject('BASE_URL') originUrl: string, private bcp: CommonSerivce, private datePipe: DatePipe, private confirmationService: ConfirmationService, private router: Router, private activatedRoute: ActivatedRoute) {
    //Rewrite Angular HTTP service after update
    //this.httpHeaders = this.bcp.getHttpHeader();

    this.httpOriginalUrl = originUrl;

    this.clearAllMessage();
    this.isLoggedIn = this.bcp.getLoginStatus();
    this.FormAccessRight = this.bcp.getAccessRightByProcess('ETSREPORT');
    this.loggedInType = this.bcp.getCurrentUserAccountType();
    this.loggedInCompanyCode = this.bcp.getCurrentCompanyCode();

    //get all list value for drop down list
    this.getCaseDomainList();
    this.getCaseStatusList('BCP');
    this.getCaseSeverityList('BCP');
    this.getReportsList();

    this.FormTitle = "Work with Tender Reports";
    this.ShowSeveritySearchFields = true;
    this.selectedTab = "Severity Performance";
    this.getReportNamebyTab(this.selectedTab);
    //this.getOustandingSeverityPerformance();        
    this.refreshSearchFields();

    this.scrollHeight = this.bcp.getDataTableHeight(0);//parameter: # of rows used for header search field
    this.scrollWidth = this.bcp.getDataTableWidth();

    //response analysis data columns
    this.responseAnalysisCols = [
      //{ field: 'action', header: 'Actions', width: '100', size: '5' },
      //{ field: 'id', header: 'ID', width: '75', size: '5' },
      { field: 'fullName', header: 'Contractor Name', width: '100', size: '5' },
      { field: 'numberInvited', header: 'No. of Invited.', width: '60', size: '10' },
      { field: 'numberSubmitted', header: 'No. of Submitted', width: '60', size: '10' },
      { field: 'numberAwarded', header: 'No. of Awarded', width: '60', size: '10' },
    ];

    //Outstanding Case Severity Performance Column Header
    this.outstandingSeverityCols = [
      //{ field: 'action', header: 'Actions', width: '100', size: '5' },
      //{ field: 'id', header: 'ID', width: '75', size: '5' },
      { field: 'domainId', header: 'Domain', width: '100', size: '5' },
      { field: 'caseNumber', header: 'Case No.', width: '150', size: '10' },
      { field: 'subject', header: 'Subject', width: '450', size: '10' },
      { field: 'caseStatus', header: 'Status', width: '150', size: '10' },
      { field: 'severity', header: 'Severity', width: '150', size: '10' },
      { field: 'createDate', header: 'Create Date', width: '150', size: '10' },
      { field: 'targetDate', header: 'Target Date', width: '150', size: '10' },
      { field: 'remainingPercentage', header: 'Remaining Percentage', width: '200', size: '10' }
    ];

    //Unknow Report Column Header
    this.testingReportCols = [

    ];
  }


  //-----------------------------------------------------------------------------
  //                      Fetch List Data for Drop Down List
  //-----------------------------------------------------------------------------
  getCaseDomainList() {
    this.http.get("api/BcpDomain/DomainList", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        //this.Case_DomainList = result.json();
        this.DomainList = result;
      });
  }


  getCaseStatusList(selectedDomain) {
    this.http.get(this.ListValueApiPath + "ByListCode/" + selectedDomain + "/STATUS", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        //this.Case_CaseStatusList = result.json();
        this.CaseStatusList = result;
      });
  }


  getCaseSeverityList(selectedDomain) {
    this.http.get(this.ListValueApiPath + "ByListCode/" + selectedDomain + "/SEVERITY", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        //this.Case_SeverityList = result.json();
        this.SeverityList = result;
      });
  }

  getReportsList() {
    this.http.get(this.PrimaryApiPath + "GetFullList/", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        //this.Case_SeverityList = result.json();
        this.Reports_List = result;
      });
  }

  getReportNamebyTab(tabName) {
    this.http.get(this.PrimaryApiPath + "GetReportNamebyTab/" + tabName, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        this.selectedReportName = result;
      });
  }


  //-----------------------------------------------------------------------------
  //                                  Show Report
  //-----------------------------------------------------------------------------
  tabViewChanged(event, tabView: TabView) {
    this.selectedTab = tabView.tabs[event.index].header;
    this.getReportNamebyTab(this.selectedTab);

    this.refreshSearchFields();
  }


  refreshSearchFields() {
    this.SearchFieldHolder = JSON.parse('{"id": 0}');
    this.SearchFieldHolder["domainId"] = this.bcp.getCurrentDomainId();
    this.SearchFieldHolder["fromDate"] = this.bcp.getCurrentDate();
    this.SearchFieldHolder["toDate"] = this.bcp.getCurrentDate();
    if (this.selectedTab == "XXSeverity Performance") {
      this.ShowSeveritySearchFields = true;
      this.ShowTestingSearchFields = false;

      this.ShowOutstandingSeverityPerformance = false;
      this.ShowTestingReport = false;

      this.SearchFieldHolder = JSON.parse('{"id": 0}');
      this.SearchFieldHolder["domainId"] = this.bcp.getCurrentDomainId();

    } else {
      if (this.selectedTab == "Testing") {
        this.ShowSeveritySearchFields = false;
        this.ShowTestingSearchFields = true;

        this.ShowOutstandingSeverityPerformance = false;
        this.ShowTestingReport = false;
      }
    }
  }


  getReport() {
    if (this.selectedTab == "Severity Performance") {
      this.getOustandingSeverityPerformance();
    } else {
      if (this.selectedTab == "Testing") {
        this.UnknowReport()
      }
    }
  }


  //Outstanding Case Severity Performance Report
  getOustandingSeverityPerformance() {
    this.ShowOutstandingSeverityPerformance = true;
    this.ShowTestingReport = false;

    if (this.SearchFieldHolder.fromDate == null) {
      this.SearchFieldHolder.fromDate = "";
    }
    if (this.SearchFieldHolder.toDate == null) {
      this.SearchFieldHolder.toDate = "";
    }
    this.stringifyValue = JSON.stringify(this.SearchFieldHolder);

    this.http.post(this.PrimaryApiPath + "outstandingSeverityPerformance/", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.OutstandingSeverityList = result;

        if (this.OutstandingSeverityList.length > 0) {
          for (var i = 0; i < this.OutstandingSeverityList.length; i++) {
            //Format Date to YYYY-MM-DD
            if (this.OutstandingSeverityList[i].createDate != null) {
              this.OutstandingSeverityList[i].createDate = this.OutstandingSeverityList[i].createDate.slice(0, 10);
            }
            if (this.OutstandingSeverityList[i].targetDate != null) {
              this.OutstandingSeverityList[i].targetDate = this.OutstandingSeverityList[i].targetDate.slice(0, 10);
            }
          }
        }
      });
  }


  //Testing Report Button
  UnknowReport() {
    this.ShowTestingReport = true;
    this.ShowOutstandingSeverityPerformance = false;
  }


  async showResponseAnalysisData() {
    this.SearchFieldHolder["fromDate"] = this.bcp.convertCalendarDateToJson(this.SearchFieldHolder["fromDate"]);
    this.SearchFieldHolder["toDate"] = this.bcp.convertCalendarDateToJson(this.SearchFieldHolder["toDate"]);
    this.stringifyValue = JSON.stringify(this.SearchFieldHolder);
    this.ResponseAnalysisList = await this.http.post(this.PrimaryApiPath + "Rpt_ResponseAnalysis", this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: any[]) => response).toPromise();
  }

  async printResponseAnalysis() {

    let fileReader = new FileReader();
    let strLine: string;
    const url = "https://sheetjs.com/data/executive.json";
    var tmpStr: string;

    //get the tender data
    this.processingReport = "ResponseAnalysis";
    this.processingFlag = "Y";
    this.SearchFieldHolder["fromDate"] = this.bcp.convertCalendarDateToJson(this.SearchFieldHolder["fromDate"]);
    this.SearchFieldHolder["toDate"] = this.bcp.convertCalendarDateToJson(this.SearchFieldHolder["toDate"]);
    this.stringifyValue = JSON.stringify(this.SearchFieldHolder);
    let recordList = await this.http.post(this.PrimaryApiPath + "Rpt_ResponseAnalysis", this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: any[]) => response).toPromise();

    //initial the worksheet and workbook
    this.strLine = "";
    this.updateExcelRow();
    let worksheet = XLSX.utils.json_to_sheet(this.excelRow, { header: [""], skipHeader: true });
    let workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "ResponseAnalysis");

    //Header Fields
    if (1 == 1) {
      //output the data
      this.strLine = "Response Analysis Report";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "For Tender Closing from " + this.SearchFieldHolder["fromDate"] + " to " + this.SearchFieldHolder["toDate"];
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Print Date: , " + this.bcp.getCurrentDate();
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Contract Name, No. of Invitation, No. of Submission, No. of Award";
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }

    for (var i = 0; i < recordList.length; i++) {
      this.strLine = "";

      tmpStr = this.bcp.convertDateTimetoDate(recordList[i].InactiveDate) == "1900-01-01" ? this.bcp.convertDateTimetoDate(recordList[i].InactiveDate) : "";
      this.strLine = this.strLine + recordList[i].fullName
        + this.delimiter + recordList[i].numberInvited
        + this.delimiter + recordList[i].numberSubmitted
        + this.delimiter + recordList[i].numberAwarded
        + this.delimiter + tmpStr;
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }

    //total section
    this.strLine = " ";
    this.updateExcelRow();
    XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

    this.strLine = "No. of Contractors: ," + recordList.length;
    this.strLine = this.strLine.replace(/,/gi, this.delimiter);
    this.updateExcelRow();
    XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

    this.fixWidth(worksheet);
    //this.applyCellFormat(worksheet);

    XLSX.writeFile(workbook, "Report_ResponseAnalysis.xlsx", { compression: true });
    this.processingFlag = "N";
    this.processingReport = "";
  }


  //-----------------------------------------------------------------------------
  //                                  Export Data
  //-----------------------------------------------------------------------------

  extractData(res: string) {
    // transforme response to blob
    let myBlob: Blob = new Blob([res], { type: 'application/forcde-download' }); // replace the type by whatever type is your response

    var fileURL = URL.createObjectURL(myBlob);
    // Cross your fingers at this point and pray whatever you're used to pray
    window.open(fileURL);
  }


  exportPDF() {

    //Define PDF Custom Fonts
    pdfMake.fonts = {
      Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf'
      }
      , NotoSansTC: {
        normal: 'NotoSansTC-Regular.otf',
        bold: 'NotoSansTC-Bold.otf'
      }
    };

    //Outstanding Cases Severity Performance Report
    if (this.selectedTab == "Severity Performance") {

      //Re-phase filter for display
      var domainFilter = 'Domain: ' + this.SearchFieldHolder.domainId
      if (this.SearchFieldHolder.fromDate) {
        var dateFilter = 'Date: ' + this.SearchFieldHolder.fromDate.toISOString().slice(0, 10) + ' to ' + this.SearchFieldHolder.toDate.toISOString().slice(0, 10);
      } else {
        var dateFilter = 'Date: ---';
      }

      //Assign Table Header and Records into List
      var ExportOutstandingSeverityList = [];
      //Header
      ExportOutstandingSeverityList.push(['Domain', 'CaseNumber', 'Subject', 'Status', 'Severity', 'Create Date', 'Target Date', 'Remaining Percentage']);
      //Data
      this.OutstandingSeverityList.map((obj) => {
        ExportOutstandingSeverityList.push([obj.domainId, obj.caseNumber, obj.subject, obj.caseStatus, obj.severity, obj.createDate, obj.targetDate, obj.remainingPercentage])
      });

      //Assign File Name when Download
      var CurrentDateTime = new Date(this.bcp.getCurrentUTCDateTime());
      var FileDateTime = CurrentDateTime.getUTCFullYear().toString() + (CurrentDateTime.getUTCMonth() + 1).toString().padStart(2, '0') + CurrentDateTime.getUTCDate().toString().padStart(2, '0') + CurrentDateTime.getHours().toString().padStart(2, '0') + CurrentDateTime.getMinutes().toString().padStart(2, '0');
      var FileName = this.selectedReportName.toString() + "_" + FileDateTime + ".pdf";

      let docDefinition = {
        //Page Setting
        pageSize: 'A4',
        pageOrientation: 'landscape',
        //Left, Top, Right, Bottom
        pageMargins: [40, 90, 40, 30],
        info: {
          title: this.selectedReportName.toString()
        },
        //Footer
        footer: function (currentPage, pageCount) {
          return [
            {
              text: currentPage.toString() + ' of ' + pageCount,
              alignment: 'center'
            }
          ]
        },
        //Header
        header: {
          margin: [40, 15, 40, 0],
          layout: 'noBorders',
          table: {
            widths: ['*', 'auto'],
            body: [
              [
                //Left Hand Size - Report Header
                {
                  //margin: [0, 15],
                  layout: 'noBorders',
                  table: {
                    widths: '*',
                    body: [
                      [
                        {
                          text: this.selectedReportName.toString(),
                          style: 'header'
                        }
                      ],
                      [
                        {
                          text: domainFilter,
                          style: 'text'
                        }
                      ],
                      [
                        {
                          text: dateFilter,
                          style: 'text'
                        }
                      ]
                    ]
                  }
                },
                //Right Hand Size - Company Logo
                {
                  image: 'BCplus_LogoOnly.png',
                  fit: [50, 50]
                }
              ]
            ]
          }
        },
        content: [
          //Table
          {
            style: 'table',
            layout: {
              hLineWidth: function (i, node) {
                return (i === 0 || i === node.table.body.length) ? 1 : 1;
              },
              vLineWidth: function (i, node) {
                return (i === 0 || i === node.table.widths.length) ? 0 : 0;
              },
              hLineColor: function (i, node) {
                return (i === 0 || i === node.table.body.length) ? 'grey' : 'grey';
              },
              vLineColor: function (i, node) {
                return (i === 0 || i === node.table.widths.length) ? 'white' : 'white';
              },
              fillColor: function (rowIndex, node, columnIndex) {
                return (rowIndex % 2 === 0) ? '#daf7d5' : null;
              },
              fillOpacity: 0.3
            },
            table: {
              //Specifies No. of starting rows of the body is header, repeated when table is continued on the sec page
              headerRows: 1,
              //Assign the width of each column
              widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
              body: ExportOutstandingSeverityList
            }
          }
        ],
        defaultStyle: {
          font: 'NotoSansTC'
        },
        styles: {
          header: {
            font: 'Roboto',
            fontSize: 14,
            bold: true,
            color: '#3C734C',
            lineHeight: 1.25,
            decoration: 'underline'
          },
          text: {
            font: 'Roboto',
            fontSize: 12,
            lineHeight: 1.25
          },
          table: {
            fontSize: 10
          }
        }
      };

      pdfMake.createPdf(docDefinition).open();
      pdfMake.createPdf(docDefinition).download(FileName);
    }


  }


  updateExcelRow() {
    const colIndexArray = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
    let dataArray: string[];
    this.excelRow = [];
    this.strLine = this.strLine.replace(/undefined/gi, "");
    this.strLine = this.strLine.replace(/Null/gi, "");
    this.strLine = this.strLine.replace(/null/gi, "");
    dataArray = this.strLine.split(this.delimiter);
    for (let index = 0; index < dataArray.length; index += 1) {
      this.excelRow[index] = dataArray[index];
    }
  }


  fixWidth(worksheet: XLSX.WorkSheet) {
    const data = XLSX.utils.sheet_to_json<any>(worksheet)
    const wscols = [
      { width: 20 }, { width: 23 }, { width: 30 }, { width: 30 }, { width: 25 }, //ABCDE
      { width: 15 }, { width: 20 }, { width: 15 }, { width: 25 }, { width: 15 }, //FGHIJ
      { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 }, //KLMNO
      { width: 15 }, { width: 15 },//PQRST
      //UVWXYZ
    ];
    worksheet["!cols"] = wscols;
    this.lastRowNumber = data.length + 1;
  }

  //-----------------------------------------------------------------------------
  //                      Checking/ Other Actions
  //-----------------------------------------------------------------------------

  //sorting event trigger, default is sorting by id
  changeSort(event) {
    if (!event.order) {
      this.sortF = 'id';
    } else {
      this.sortF = event.field;
    }
  }


  clearAllMessage() {
    this.searchErrorMsgs = [];
    this.InputErrorMsg = [];
    this.resultMsgs = [];
  }

  //Redirect to edit case page when click from report module
  editRecord(caseId) {
    this.router.navigate(['/home/case'], { queryParams: { caseId: caseId, report: "outstandingSeverity" } });
  }

}


interface IOutstandingSeverity {
  id?;
  domainId?;
  caseNumber?;
  subject?;
  caseStatus?;
  severity?;
  createDate?;
  targetDate?;
  remainingPercentage?;
}

interface IResponseAnalysis {
  fullName?;
  numberInvited?;
  numberSubmitted?;
  numberAwarded?;
}

interface IDomainValue {
  label?;
  value?;
}

interface ICodeValue {
  label?;
  value?;
}

interface Message {
}

interface IReportsListValue {
  tabName?;
  reportName?;
}

interface ISeveritySearchFields {
  domainId?;
  fromDate?;
  toDate?;
}
